/**
 * Created by hp on 2017/8/2.
 */
const defaults = {
    showSubscribeChannel: false,
    channel: {
        qrcode: '',
        id: '',
        name: '',
        cover: '',
        isSubscribed: false,
    },
    callback: null,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'SUBSCRIBE_CHANNEL_SHOW':
            return {...state, showSubscribeChannel: true, channel: action.payload};
        case 'SUBSCRIBE_CHANNEL_HIDE':
            return {...state, showSubscribeChannel: false};
        case 'SUBSCRIBE_CHANNEL_SUBSCRIBE':
            return {...state, showSubscribeChannel: false, isSubscribed: true};
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/subscribeChannel.js